import {
  getGridColumnState as getGridColumnStateFromServer,
  saveGridColumnState
} from "@q-food/q-food";
import { ColumnState } from "ag-grid-community";
import { useUserStore } from "./User";

export const useUserSettingsStore = defineStore("UserSettings", () => {
  const { activeUser } = storeToRefs(useUserStore());

  const userSettings = computed(() => {
    if (!activeUser.value) {
      throw new Error("No active user");
    }

    return activeUser.value.settings;
  });

  // Sync these three with backend
  const automaticRecalculation = computed(
    () => new Set(userSettings.value.automaticRecalculation)
  );
  const smartTabs = computed(() => userSettings.value.smartTabs);

  const defaultScale = computed(() => userSettings.value.defaultScale);
  const defaultScannerId = computed(() => userSettings.value.defaultScannerId);

  const gridColumnState = ref<{ [gridKey: string]: ColumnState[] }>({});

  async function getGridColumnState(gridKey: string) {
    if (!(gridKey in gridColumnState.value)) {
      gridColumnState.value[gridKey] = (await getGridColumnStateFromServer(
        gridKey
      )) as unknown as ColumnState[];
    }

    return gridColumnState.value[gridKey];
  }

  async function setGridColumnState(
    gridKey: string,
    columnState: ColumnState[]
  ) {
    gridColumnState.value[gridKey] = columnState;

    await saveGridColumnState(gridKey, JSON.stringify(columnState));
  }

  return {
    gridColumnState: readonly(gridColumnState),
    userSettings: readonly(userSettings),
    automaticRecalculation,
    smartTabs,
    defaultScale,
    defaultScannerId,
    getGridColumnState,
    setGridColumnState
  };
});
